import { useState, useRef, useEffect, Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import {
    AppBar,
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    CircularProgress,
    Divider,
    Grid2 as Grid,
    MenuItem,
    Select,
    Toolbar,
    Tooltip,
    Typography,
} from '@mui/material';
import { AccountCircle, Add, AgricultureOutlined, ArrowCircleLeft, ArrowCircleRight, ArrowLeft, Backspace, Delete, Download, Edit, FilterAlt, Info, Menu, Message, PictureAsPdf, PlayArrow, QrCode, Rule, Search } from '@mui/icons-material';
import { myFormat, myTimestampToDate, propComparator, propComparatorB, propComparatorDate } from "../utils/ui_utils";

import { CowDialog } from "../modals/CowDialog";
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { add_Cow, clear_all_cows, delete_Cow, edit_Cow, get_Cow_list, get_cows_live } from "../FirebaseUtils/dbCow";
import { ImportFileDialog } from "../modals/ImportFileDialog";
import { useEvent } from "../context/eventContext";
import { ContainerPdfDialog } from "../modals/PdfContainerDialog";
import { useAuth } from "../core/AuthProvider";
import { globalstyles } from "../lib/definitions";
import { PresenceButton, PresenceSummary } from "../components/PresenceButton";
import { memo } from "react";
import { CowtypeBadge, CowtypeButton } from "../components/CowtypeButton";
import MultiColorProgressBar from "../components/MultiColorProgressBar";
import CowpageMenu from "../components/menu/CowpageMenu";
import { CategoryLabel, CategoryRow } from "../definitions/category";
import { CatalogInitNumberDialog } from "../modals/CatalogInitNumberDialog";
import { NavigationButtons } from "../components/NavigationButtons";
import { SortButton } from "../components/SortButton";
import { CowBirthdate } from "../definitions/cow";
import { lazy } from 'react';
import { FilterSearchBar } from "../components/CowpageFiltersearch";
import ExportCSV from "../components/ExportCsv";
import { CowGroupviewDialog } from "../modals/CowGroupviewDialog";


const OneCow = lazy(() => import("../components/OneCow").then(module => ({ default: module.OneCow })))

const checkFilter = (filterApplied, c) => {
    //console.log(filterApplied.property_list, filterApplied.property_list.map(p => p.id).includes(c.property?.id))
    if (
        //        (filterApplied.show_not_present === true || c.is_present !== false)
        (filterApplied.show_presence.includes(c.is_present))
        && (!filterApplied.show_type || c.cow_type === filterApplied.show_type)
        && (!filterApplied.show_custom || c[filterApplied.show_custom] === true)
        && (!filterApplied.birth || (filterApplied.birth[0] <= c.birth && filterApplied.birth[1] >= c.birth))
        && (filterApplied.property_list.length === 0 || filterApplied.property_list.map(p => p.id).includes(c.property?.id))
        && (filterApplied.cowman_list.length === 0 || filterApplied.cowman_list.map(p => p.id).includes(c.cowman?.id))
        && (filterApplied.category_list.length === 0 || filterApplied.category_list.map(p => p.id).includes(c.category?.id))
    ) {
        /*         console.log(
                    (filterApplied.show_presence.includes(c.is_present))
                    , (!filterApplied.show_type || c.cow_type === filterApplied.show_type)
                    , (!filterApplied.birth || (filterApplied.birth[0] <= c.birth && filterApplied.birth[1] >= c.birth))
                    , (filterApplied.property_list.length === 0 || filterApplied.property_list.map(p => p.id).includes(c.property?.id))
                    , (filterApplied.cowman_list.length === 0 || filterApplied.cowman_list.map(p => p.id).includes(c.cowman?.id))
                    , (filterApplied.category_list.length === 0 || filterApplied.category_list.map(p => p.id).includes(c.category?.id))
        
                ) */
        return true
    }
    return false

}

const page_element_count_preset = [10, 25, 50, 100, 200, 300]

const SIDEBAR_SIZE = 3



export default function CowListPage() {
    const dialogRef = useRef()
    const pdfDialog = useRef()
    const groupDialog = useRef()
    const childRefDelete = useRef()
    const { user } = useAuth()
    const { selEvent, pageElementCount, setPageElementCount } = useEvent()
    const [element_list, setElementList] = useState([])
    const [filtered_element_list, setFilteredElementList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isSubLoading, setIsSubLoading] = useState(true)
    const [showSearch, setShowSearch] = useState(false)
    const [filterApplied, setFilterApplied] = useState({ show_not_present: false, birth: [0, 20], age: [1, 180], property_list: [], cowman_list: [], category_list: [], show_presence: [true, undefined] })
    const [search_text, setSearchText] = useState('')
    const [view_list, setViewList] = useState({ last_index: -1, list: [], cur_page: 0 })
    const [viewMode, setViewMode] = useState('edit')
    const [sortProp, setSortProp] = useState({ sortparam: 'catalog_id', sortdirection: 1 })


    const ev_date = selEvent && selEvent.event_start && myTimestampToDate(selEvent.event_start)

    const handleNew = () => {
        dialogRef.current.onNew()
    }

    useEffect(() => {
        console.log("filterAppplied", filterApplied)
        if (search_text.length > 0) {
            doSearch()
        } else {
            doSearch('')
        }

    }, [filterApplied])

    const doSearch = (st) => {
        console.log("SEARCH", st, st.length)
        if (st) {
            if (st.length > 0) {
                setFilteredElementList(
                    element_list.filter(c =>
                        checkFilter(filterApplied, c)
                        && ((c.catalog_id && String(c.catalog_id).includes(st))
                            || c.name.toLowerCase().includes(st))
                        || c.serial.toLowerCase().includes(st)
                    ))

            } else {
                setFilteredElementList(
                    element_list.filter(c =>
                        checkFilter(filterApplied, c)
                    ))

            }

        } else {
            setFilteredElementList(
                element_list.filter(c =>
                    checkFilter(filterApplied, c)
                    && ((c.catalog_id && String(c.catalog_id).includes(st))
                        || c.name.toLowerCase().includes(st))
                    || c.serial.toLowerCase().includes(st)
                ))

        }

    }


    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }

    const handleCleanData = () => {
        const cb = async () => {
            setIsLoading(true)
            const res = await clear_all_cows(selEvent.id)
            console.log("RES", res)
            setElementList([])
        }
        childRefDelete.current.confirmDelete('Cancella tutti i soggetti', `Sei sicuro di voler cancellare <b>TUTTI I SOGGETTI</b>? <br/> quest'azione non è annullabile`, cb)
    }

    const handleShowPdf = (t) => {
        if (t === 'c') {
            pdfDialog.current.onOpen(element_list, 'cartelli', 'singleboard')
        } else if (t === 'p') {
            pdfDialog.current.onOpen(element_list, 'pettorali', 'number')
        } else {
            groupDialog.current.onOpen(element_list)
        }
        //pdfDialog.current.onOpen(view_list.list[view_list.cur_page])
    }

    const handleSinglePdf = (type, cow) => {
        if (type === 'c') {
            pdfDialog.current.onOpen([cow], 'cartello', 'singleboard')
        } else {
            pdfDialog.current.onOpen([cow], 'pettorale', 'number')
        }
    }

    const handleDelete = (r, i, p) => {
        console.log("DELETE", r, i)
        const cb = () => {
            const a = delete_Cow(selEvent.id, r.id)
            console.log("RESULT DELETE", r.id, a)
            setElementList(lst => {
                let _el = [...lst]
                _el.splice(i, 1)
                return _el
            })
        }
        if (selEvent.lock_catalog === true) {
            editFn({ ...r, is_present: p })
        } else {
            childRefDelete.current.confirmDelete('Cancella soggetto', `Sei sicuro di voler cancellare il soggetto: <b>${r.name}</b> ${r.serial}`, cb)
        }
    }
    const editParam = (r, i, p, v) => {
        console.log("liveEdit", r, i, p, v)
        editFn({ ...r, [p]: v })
    }

    const addFn = async (el) => {
        const res = await add_Cow(user.uid, selEvent.id, el)
        //reloadFn()
    }

    const editFn = async (el) => {
        console.log(user.uid, selEvent.id, el.id)
        const res = await edit_Cow(user.uid, selEvent.id, el.id, el)
        // reloadFn(el)
    }

    const reloadFn = async (el) => {

    }

    const getLastCatalogNumber = () => {
        const cl = element_list.filter(c => c.catalog_id !== undefined).sort(propComparator('catalog_id'))
        cl.reverse()
        if (cl[0]) {
            return cl[0].catalog_id
        } else {
            return 0
        }
    }

    const goPrevPage = () => {
        setViewList(v => ({ ...v, cur_page: v.cur_page - 1 }))
    }


    const goNextPage = () => {
        setViewList(v => ({ ...v, cur_page: v.cur_page + 1 }))
    }


    const updateFilterApplied = (p, v, t) => {
        if (t === 'list') {
            setFilterApplied(f => {
                let _fp = [...f[p]]
                const c = _fp.indexOf(v)
                if (c >= 0) {
                    _fp.splice(c, 1)
                } else {
                    _fp.push(v)
                }
                return { ...f, [p]: _fp }

            })

        } else {
            setFilterApplied(f => (
                { ...f, [p]: v }
            ))

        }
    }

    const toggleViewMode = (v) => {
        setViewMode(t => {
            if (t === 'edit') {
                setFilterApplied(f => ({ ...f, show_not_present: true, show_presence: [true, false, undefined] }))
                return v
            } else {
                return 'edit'
            }
        })

    }


    useEffect(() => {

        document.title = 'ShowTime ANAFIBJ - lista soggetti';
        let unsubscribe = () => {
            setElementList([])
        }

        const ev_callback = (cow_dict_data) => {
            console.log("CUR cow live data ", cow_dict_data)
            setElementList(el => {
                let _el = [...el]
                if (cow_dict_data.removedList.length > 0) {
                    const r_index_list = cow_dict_data.removedList.map(c => c.id)
                    _el = _el.filter(e => !r_index_list.includes(e.id))
                }
                if (cow_dict_data.modifiedList.length > 0) {
                    const _el_index_list = _el.map(c => c.id)
                    for (const m of cow_dict_data.modifiedList) {
                        const c = _el_index_list.indexOf(m.id)
                        _el.splice(c, 1, m)
                    }
                }
                _el = [..._el, ...cow_dict_data.addedList]
                _el.sort(propComparator('catalog_id'))
                return _el
            })
            //            unsubscribe = setElementList(cow_dict_data)
        }
        const initLive = async () => {
            console.log("INIT DATA")
            if (selEvent.id) {
                const cs = await get_cows_live(selEvent.id, ev_callback)
            }
        }
        initLive()
        return () => {
            try {
                unsubscribe()
            } catch (err) {

            }
        }



    }, [selEvent])



    const generateViewList = () => {
        let _view_list = []
        console.log("DO SET VIEW", filtered_element_list.length)
        if (filtered_element_list.length > 0) {
            if (pageElementCount !== 'all') {
                for (let i = 0; i < filtered_element_list.length; i += pageElementCount) {
                    const chunk = filtered_element_list.slice(i, i + pageElementCount);
                    _view_list.push(chunk)
                }

            } else {
                _view_list = [[...filtered_element_list]]
            }
        }
        if (view_list.cur_page < view_list.list?.length) {
            setViewList(v => ({ ...v, list: _view_list }))
        } else {
            setViewList({ list: _view_list, cur_page: 0 })
        }
        setIsLoading(false)
        setIsSubLoading(false)


    }


    useEffect(() => {
        setIsSubLoading(true)
        setElementList(el => {
            let _el = [...el]
            if (sortProp?.sortparam === 'property') {
                _el.sort(propComparatorB('property', 'name'))
            } else if (sortProp?.sortparam === 'category') {
                console.log("SORT CATEGORY")
                _el.sort(propComparatorB('category', 'category_number', undefined))
            } else if (sortProp?.sortparam === 'birthdate') {
                _el.sort(propComparatorDate('birthdate'))
            } else {
                _el.sort(propComparator(sortProp.sortparam))

            }
            if (sortProp.sortdirection < 0) {
                _el.reverse()
            }
            return _el
        })


    }, [sortProp])


    useEffect(() => {
        generateViewList()
    }, [filtered_element_list, pageElementCount])


    useEffect(() => {
        console.log("DO SET FILTER", sortProp, element_list[0])
        setFilteredElementList(
            element_list.filter(c =>
                checkFilter(filterApplied, c)
            ))

    }, [element_list, filterApplied])


    const ImportDialogContent = () => {
        return <ImportFileDialog reloadFn={reloadFn} cow_list={element_list} />
    }

    const CatalogInitNumberDialogContent = () => {
        return <CatalogInitNumberDialog cow_list={element_list} reloadFn={reloadFn} />
    }


    const ExportCSVContent = () => {
        return <ExportCSV data={element_list.filter(c => c.is_present)} fileName={`${selEvent.event_name}_soggetti.csv`} title={`PRESENTI ALLA MOSTRA ${selEvent.event_name} del ${myFormat(selEvent.event_start, 'dd/MM/yyyy')}`} />
    }


    const CatLabel = ({ category }) => {
        if (category) {
            return (
                <CategoryLabel element={category} />
            )
        } else {
            return <></>
        }

    }



    return (
        <Box sx={{ textAlign: 'center', p: 1.5 }}>

            <DeleteconfirmationSection ref={childRefDelete} />
            <CowDialog ref={dialogRef} getLastCatalogNumber={getLastCatalogNumber} addFn={addFn} editFn={editFn} />
            <ContainerPdfDialog ref={pdfDialog} />
            <CowGroupviewDialog ref={groupDialog} />
            <AppBar elevation={0} style={globalstyles.secondaryAppBar}>

                <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <Grid size={"grow"} sx={{ fontSize: '1.2em', fontWeight: 'bold', textAlign: 'left' }}>
                        Lista Soggetti <Chip size="small" label={<>{filtered_element_list.length !== element_list.length ? <>{filtered_element_list.length}/</> : ''}{element_list.length}</>} />
                    </Grid>
                    <Grid size="grow">
                        {element_list.length > 0 &&
                            <Select
                                labelId="groupby-label"
                                id="groupby"
                                value={pageElementCount}
                                size="small"
                                label="elementi visualizzati per pagina"
                                onChange={(ev) => setPageElementCount(ev.target.value)}
                                sx={{ fontSize: '0.8em' }}
                            >
                                {page_element_count_preset.filter(g => g < element_list.length).map((g, gk) => (
                                    <MenuItem key={gk} value={g} sx={{ fontSize: '0.8em' }}>
                                        {g} soggetti
                                    </MenuItem>
                                ))}
                                <Divider />
                                <MenuItem value={"all"} sx={{ fontSize: '0.8em' }}>
                                    tutti {element_list.length} soggetti
                                </MenuItem>
                            </Select>
                        }
                    </Grid>
                    <Grid size="grow">
                        {element_list.length !== filtered_element_list.length &&
                            <>
                                <PresenceSummary element_list={filtered_element_list} title="soggetti filtrati" />
                                /
                            </>
                        }
                        <PresenceSummary element_list={element_list} title="tutti i soggetti" />
                    </Grid>
                    <Grid size="grow">
                        {viewMode === 'presence' &&
                            <span>
                                <MultiColorProgressBar element_list={element_list} param="is_present" />
                            </span>
                        }
                    </Grid>
                    <Grid size={"auto"} sx={{ textAlign: 'right' }} alignItems={"center"}>
                        <ButtonGroup size="small">
                            <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuovo soggetto </Button>

                            {viewMode === 'edit' &&
                                <CowpageMenu
                                    show={element_list.length > 0}
                                    handlePdf={handleShowPdf}
                                    handleClean={handleCleanData}
                                    ImportContent={ImportDialogContent}
                                    CatalogInit={CatalogInitNumberDialogContent}
                                />
                            }
                        </ButtonGroup>
                    </Grid>
                    {element_list.length > 0 &&
                        <>
                            {selEvent.custom_cow_filter_param_list && selEvent.custom_cow_filter_param_list.length > 0 &&
                                <Grid size={"auto"} sx={{ textAlign: 'center' }}>
                                    <Button onClick={() => toggleViewMode('customparam')} size="small" variant={viewMode === 'customparam' ? 'contained' : 'outlined'} color="secondary" startIcon={<Rule />}>campi filtro</Button>
                                </Grid>
                            }
                            <Grid size={"auto"} sx={{ textAlign: 'center' }}>
                                <Button onClick={() => toggleViewMode('presence')} size="small" variant={viewMode === 'presence' ? 'contained' : 'outlined'} color="secondary" startIcon={<Rule />}>gestione presenze</Button>
                            </Grid>
                            <Grid size={"auto"} sx={{ textAlign: 'center' }}>
                                <Button variant={showSearch ? 'contained' : 'outlined'} color="secondary" onClick={() => setShowSearch(s => !s)} startIcon={<FilterAlt />} endIcon={<Search />}></Button>
                            </Grid>
                        </>
                    }
                </Grid>
                <Grid container spacing={1}>
                    <Grid size="grow">
                        {view_list.list[view_list.cur_page]?.length > 0 ?
                            <>
                                <Grid container sx={globalstyles.listHeader}>
                                    <Grid size={0.5} sx={{ justifyContent: "center" }} container>
                                        <Grid>
                                            catalogo
                                        </Grid>
                                        <Grid>
                                            <SortButton setSortProp={setSortProp} p={'catalog_id'} sortProp={sortProp} />
                                        </Grid>
                                    </Grid>
                                    <Grid size={1}>
                                        <Grid>
                                            matricola
                                        </Grid>
                                        <Grid>
                                            <SortButton setSortProp={setSortProp} p={'serial'} sortProp={sortProp} />
                                        </Grid>
                                    </Grid>
                                    <Grid size="grow" sx={{ justifyContent: "center" }} container >
                                        <Grid>
                                            nome
                                        </Grid>
                                        <Grid size="auto">
                                            <SortButton setSortProp={setSortProp} p={'name'} sortProp={sortProp} />
                                        </Grid>
                                    </Grid>
                                    <Grid size="grow" sx={{ justifyContent: "center" }} container>
                                        <Grid>
                                            Proprietà<br />
                                            <Box sx={{ fontSize: '0.7em', fontStyle: 'italic' }}>comproprietà</Box>
                                        </Grid>
                                        <Grid>
                                            <SortButton setSortProp={setSortProp} p={'property'} sortProp={sortProp} />
                                        </Grid>
                                    </Grid>
                                    <Grid size={1} sx={{ justifyContent: "center" }} container>
                                        <Grid>
                                            data di nascità<br />
                                            <Box sx={{ fontSize: '0.7em', fontStyle: 'italic' }}> età (mesi) </Box>
                                        </Grid>
                                        <Grid>
                                            <SortButton setSortProp={setSortProp} p={'birthdate'} sortProp={sortProp} />
                                        </Grid>
                                    </Grid>
                                    {viewMode === 'edit' &&
                                        <>
                                            <Grid size={1} sx={{ justifyContent: "center" }} container>
                                                <Grid>
                                                    Parti<br />
                                                    <Box sx={{ fontSize: '0.7em', fontStyle: 'italic' }}> data ultimo parto</Box>
                                                </Grid>
                                                <Grid>
                                                    <SortButton setSortProp={setSortProp} p={'birth'} sortProp={sortProp} />
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                    <Grid size="grow" sx={{ justifyContent: "center" }} container>
                                        <Grid>
                                            Categoria
                                        </Grid>
                                        <Grid>
                                            <SortButton setSortProp={setSortProp} p={'category'} sortProp={sortProp} />
                                        </Grid>
                                    </Grid>
                                    <Grid size={viewMode === 'presence' ? 5 : "auto"} >
                                        <NavigationButtons view_list={view_list} goNextPage={goNextPage} goPrevPage={goPrevPage} />
                                    </Grid>

                                </Grid>

                            </>
                            :
                            <Grid >
                            </Grid>
                        }
                    </Grid>
                    {showSearch &&
                        <Grid style={{ color: 'black', fontSize: '0.8em' }} size={SIDEBAR_SIZE} container>
                        </Grid>
                    }
                </Grid>
            </AppBar>
            <Toolbar  style={{marginBottom:15}}/>
            {isLoading ?
                <CircularProgress />
                :
                <Grid container spacing={1}>
                    <Grid size="grow">
                        {view_list.list[view_list.cur_page]?.length > 0 ?
                            <>
                                {isSubLoading ?
                                    <></>
                                    :
                                    <Grid >
                                        {view_list.list[view_list.cur_page].map((cow, k) => (
                                            <OneCowLazy
                                                key={k}
                                                cow={cow}
                                                ev_date={ev_date}
                                                index={k + (pageElementCount * view_list.cur_page)}
                                                CategoryLabel={CatLabel}
                                                viewMode={viewMode}
                                                custom_cow_filter_param_list={selEvent.custom_cow_filter_param_list || []}
                                                lock_catalog={selEvent?.lock_catalog}
                                                handleEdit={() => handleEdit(cow, getIndex(k, pageElementCount, view_list.cur_page))}
                                                handlePdf={(t) => handleSinglePdf(t, cow, getIndex(k, pageElementCount, view_list.cur_page))}
                                                editParam={(p, v) => editParam(cow, getIndex(k, pageElementCount, view_list.cur_page), p, v)}
                                                handleDelete={(p) => handleDelete(cow, getIndex(k, pageElementCount, view_list.cur_page), p)}
                                            />
                                        ))}
                                    </Grid>
                                }
                            </>
                            :
                            <Grid >
                                {element_list.length === 0 ?
                                    <Typography sx={globalstyles.missing_value}>
                                        Nessun soggetto ancora inserito
                                    </Typography>
                                    :
                                    <>
                                        Nessun soggetto trovato con i filtri applicati
                                    </>
                                }
                            </Grid>
                        }
                    </Grid>
                    {showSearch &&
                        <Grid size={SIDEBAR_SIZE}>
                            <FilterSearchBar sidebar_size={"grow"} search_text={search_text} setSearchText={setSearchText} filterApplied={filterApplied} updateFilterApplied={updateFilterApplied} doSearch={doSearch} />
                        </Grid>
                    }
                </Grid>
            }

        </Box >
    );
}

const getIndex = (k, pgc, cp) => {
    if (pgc !== 'all') {
        return k + (pgc * cp)
    } else {
        return k

    }
}


const OneCowLazy = (props) => {
    return (
        <Suspense fallback={<OneCowSlim {...props} />}>
            <OneCow {...props} />
        </Suspense>
    )
}


const OneCowSlim = memo(({ cow, ev_date, viewMode, handleEdit, handleDelete, lock_catalog }) => {

    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.8em', backgroundColor: getBgColor(cow.is_present) }}>
            <Grid size={0.5}>
                {cow.catalog_id}
            </Grid>
            <Grid size={1} flexDirection={"row"} container>
                <CowtypeBadge cow_type={cow.cow_type} />
                {cow.serial}
            </Grid>
            <Grid size={"grow"}>
                {cow.name}
            </Grid>
            <Grid size={"grow"} sx={{ fontSize: '0.8em' }}>
                {cow.cowman && cow.cowman.id && <AgricultureOutlined sx={{ fontSize: '14px', color: 'grey' }} />}
                {cow.property?.name}
                <Box sx={{ color: 'grey', fontStyle: 'italic' }}>{cow.coproperty}</Box>
            </Grid>
            <Grid size={1}>
                <CowBirthdate ev_date={ev_date} birthdate={cow.birthdate} show_age={true} />
            </Grid>
            {viewMode === 'edit' &&
                <>
                    <Grid size={1}>
                        {cow.birth}
                        {cow.birth > 0 && cow.last_birthdate &&
                            <Box sx={{ color: 'grey', fontStyle: 'italic' }}>
                                {myFormat(cow.last_birthdate, 'dd/MM/yyyy')}
                            </Box>
                        }
                    </Grid>
                </>
            }
            <Grid size={"grow"}>
            </Grid>
            <Grid size="grow">
                <CircularProgress size='1em' />
                <ButtonGroup size="small">
                    <Tooltip title="modifica">
                        <Button color="warning" onClick={handleEdit} startIcon={<Edit color="warning" />}></Button>
                    </Tooltip>
                    {!lock_catalog && viewMode === 'edit' &&
                        <Tooltip title="cancella">
                            <Button color="error" onClick={handleDelete} startIcon={<Delete />}></Button>
                        </Tooltip>
                    }
                </ButtonGroup>
            </Grid>
        </Grid>

    )
})

const getBgColor = (is_present) => {
    if (is_present === undefined) {
        return '#ccc'
    } else if (is_present === false) {
        return '#ebabab'
    } else {
        return ''
    }
}



